import React, { useState } from 'react';

import { WithApp } from 'contexts/appContext';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles, TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import { Autocomplete } from '@material-ui/lab';
import { Close, DoneAll, Search } from '@material-ui/icons';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import ButtonDelete from 'hooks/ButtonDelete';

import { wsFindBy, wsCreate, wsUpdate, wsRemove } from 'services/WService';
import ModalFilterProduct from 'components/Tvendo/Common/ModalFilterArticle';
import { currency, nInt, onlyInteger } from 'hooks/Pipe';

const useStyles = makeStyles({
  input: {
    '& input': {
      textAlign: 'right'
    }
  }
});

const columns = [
  { field: '', title: 'Código', width: 200 },
  { field: '', title: 'Producto' },
  { field: '', title: 'Cód. cuenta', align: 'center', width: 140 },
  { field: '', title: 'Unit Empaque', align: 'center', width: 120 },
  { field: '', title: 'UM', align: 'center', width: 100 },
  { field: 'unit_price', title: 'P. Unit', width: 120 },
  { field: '', title: 'Stock actual', width: 120 },
  { field: '', title: 'Cantidad', width: 120 },
  { field: 'total', title: 'Monto', width: 130, align: 'center' },
  { field: 'total_igv', title: 'Monto con igv', width: 130, align: 'center' },
  { field: '', title: 'Acciones', width: 100, align: 'center' }
];

export default WithApp(function DetailKardex(props) {
  const classes = useStyles();

  const {
    type,
    entity,
    dataHeader,
    productSelecteds,
    setProductSelecteds,
    showNotify,
    getKardex,
    stateK,
    setStateK,
    warehouseId,
  } = props;

  const permission = {
    store:
      type === 'ET'
        ? 'LOGI_ENTRIES_STORE'
        : type === 'OT'
        ? 'LOGI_OUTPUTS_STORE'
        // : type === 'ETI' || type === 'OTI'
        // ? 'LOGI_INVENTORIES_STORE'
        : 'LOGI_TRANSFERS_UPDATE',
    update:
      type === 'ET'
        ? 'LOGI_ENTRIES_UPDATE'
        : type === 'OT'
        ? 'LOGI_OUTPUTS_UPDATE'
        // : type === 'ETI' || type === 'OTI'
        // ? 'LOGI_INVENTORIES_UPDATE'
        : 'LOGI_TRANSFERS_UPDATE',
    confirm:
      type === 'ET'
        ? 'LOGI_ENTRIES_CONFIRM'
        : type === 'OT'
        ? 'LOGI_OUTPUTS_CONFIRM'
        : 'LOGI_TRANSFERS_CONFIRM'
  };

  const [openModalProduct, setOpenModalProduct] = useState(false); //Abrir modal
  const [productSelected, setProductSelected] = useState({ ItemCode: '', ItemName: '' });
  const [products, setProducts] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  async function getProduct(ItemCode) {
    let response = await wsFindBy('logi/product-stock', {
      ItemCode,
      logi_warehouse_id: warehouseId,
    });
    if (response.success) {
      setProducts(response.data);
    } else {
      showNotify('No se encontró el producto', 'info');
      setProductSelected({});
      setProducts([]);
    }
  }

  const handleChangeProduct = (e) => {

    // Validar stocks si es salida de inventario
    if(type === 'OT'){
      if(e.target.name === 'quantity'){
        if (e.target.value > productSelected.stock) return;
      }
    }

    setProductSelected({
      ...productSelected,
      [e.target.name]: e.target.value,
      total: parseFloat(e.target.value || 0) * parseFloat(productSelected.unit_price || 0),
      total_igv: parseFloat(e.target.value || 0) * parseFloat(productSelected.unit_price || 0),
    });
  };

  const handleChangeRow = (e, id) => {
    let cloneRows = [...productSelecteds];
    if (id !== undefined) {
      let objIndex = cloneRows.findIndex((obj) => obj.id == id);
      cloneRows[objIndex][e.target.name] = e.target.value;
      cloneRows[objIndex].total = (cloneRows[objIndex].unit_price || 0) * (e.target.value || 0);
      setProductSelecteds([...cloneRows]);
    }
  };

  async function addArticleStock(article) {
    const exisId = productSelecteds.find((item) => item.logi_product_id == article.id);
    if (exisId) {
      showNotify('Ya existe este producto', 'info');
      return;
    }

    if (article.last_purchase_price === null || article.last_purchase_price == 0) {
      showNotify('Este producto no tiene último precio compra\n✍ Agrégalo manualmente', 'info');
    }

    let stock = 0;
    if(Array.isArray(article.stocks) && article.stocks.length > 0){
      stock = parseInt(article.stocks[0].OnHand - article.stocks[0].IsCommited);
    }

    setProductSelected({
      ...article,
      unit_price: article.last_purchase_price,
      stock,
      total: 0,
      digitate_packages: 0,
      digitate_units: 0
    });
  }

  async function saveDetail(productSelected) {
    setIsButtonDisabled(true);
    const data = {
      logi_product_id: productSelected.id,
      quantity: productSelected.quantity
    };

    if (productSelected.last_purchase_price === null || productSelected.last_purchase_price == 0) {
      data.price = productSelected.unit_price;

      if (data.price < 0 || !data.price) {
        showNotify('Ingrese un precio válido', 'info');
        setIsButtonDisabled(false);
        return;
      }
    }

    if (data.quantity < 0 || !data.quantity) {
      showNotify('Ingrese una cantidad válida', 'info');
      setIsButtonDisabled(false);
      return;
    }

    let response = await wsCreate(`${entity}/${dataHeader.id}/detail`, data);
    if (response.success) {
      showNotify(response.message);
      getKardex(dataHeader.id);
      setProductSelected({});
    } else {
      showNotify(response.message, 'error');
    }
    setIsButtonDisabled(false);
  }

  async function updateDetail(id, data) {
    let response = await wsUpdate(`${entity}/${dataHeader.id}/detail`, id, data);
    if (response.success) {
      showNotify(response.message);
      getKardex(dataHeader.id);
    } else {
      getKardex(dataHeader.id);
      showNotify(response.message, 'error');
    }
  }
  // Ya no se usa (La diferencia es en el mensaje de eliminación con esta funcion no se muestra)
  async function deleteDetail(id) {
    let response = await wsRemove(`${entity}/${dataHeader.id}/detail`, id);
    if (response.success) {
      showNotify(response.message);
      getKardex(dataHeader.id);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function changeStateK(state) {
    setIsButtonDisabled(true);
    let response = await wsUpdate(`${entity}/${dataHeader.id}/change-state`, {
      state_migrate: state,
    });
    if (response.success) {
      showNotify(response.message);
      getKardex(dataHeader.id);
    } else {
      setStateK(state === 'D' ? true : false);
      showNotify(response.message, 'error');
    }
    setIsButtonDisabled(false);
  }

  return (
    <>
      <ModalFilterProduct
        open={openModalProduct}
        setOpen={setOpenModalProduct}
        setProductSelect={(item) => {
          addArticleStock(item);
        }}
        entity="logi/product-stock"
        filterCustom={{ logi_warehouse_id: warehouseId }}
      />
      <TableContainer component={Paper}>
        <Table style={{ minWidth: 1500 }} size="small" aria-label="tabla detalle de kardex">
          <TableHead>
            <TableRow>
              <TableCell width="50">#</TableCell>
              {columns.map((item, i) => {
                return (
                  <TableCell key={i} width={item.width} align={item.align}>
                    {item.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {/* Busqueda producto */}
              <TableCell>
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  round
                  justIcon
                  simple
                  onClick={() => setOpenModalProduct(true)}
                  disabled={stateK}
                >
                  <Search style={{ width: '27px', height: '27px' }} />
                </Button>
              </TableCell>
              {/* Busqueda producto ItemCode */}
              <TableCell>
                <Autocomplete
                  options={products}
                  getOptionLabel={(option) => option.ItemCode}
                  disabled={stateK}
                  renderInput={(params) => (
                    <TextField {...params} margin="normal" size="small" required />
                  )}
                  onInputChange={(e) => {
                    if (e.target.value?.length > 3) {
                      getProduct(e.target.value);
                    } else {
                      setProductSelected({});
                    }
                  }}
                  noOptionsText="Mínimo 4 caracteres"
                  clearOnEscape={true}
                  clearOnBlur={false}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && products.length === 1) {
                      addArticleStock(products[0]);
                      setProducts([]);
                    }
                  }}
                  onChange={(e, item) => {
                    if (!!item) {
                      addArticleStock(item);
                    } else {
                      setProductSelected({});
                      setProducts([]);
                    }
                  }}
                />
              </TableCell>
              {/* Nombre producto */}
              <TableCell>{`${(productSelected.ItemCode || '') + ' -' || ''} ${
                productSelected.ItemName || ''
              }`}</TableCell>
              {/* AcctCode */}
              <TableCell align="center">{productSelected.AcctCode || '-'}</TableCell>
              <TableCell align="center">{productSelected.BuyUnitMsr !== undefined ? `${productSelected.BuyUnitMsr} (${parseFloat(productSelected.NumInSale)})` : '-'}</TableCell>
              <TableCell align="center">PZA (1)</TableCell>
              {/* Ultimo precio compra */}
              <TableCell align="right" key={productSelected.last_purchase_price}>
                {productSelected.last_purchase_price === null ||
                productSelected.last_purchase_price == 0 ? (
                  <TextField
                    name="unit_price"
                    value={productSelected.unit_price || ''}
                    onChange={handleChangeProduct}
                    type="number"
                    margin="normal"
                    size="small"
                    inputProps={{ min: 0 }}
                    fullWidth
                    className={classes.input}
                    disabled={stateK}
                  />
                ) : (
                  currency(productSelected.unit_price) || '-'
                )}
              </TableCell>

              {/* Stock disponible */}
              <TableCell>{productSelected.stock}</TableCell>

              {/* Cantidad a seleccionar */}
              <TableCell>
                <TextField
                  name="quantity"
                  value={productSelected.quantity || ''}
                  onChange={handleChangeProduct}
                  onKeyPress={onlyInteger}
                  margin="normal"
                  size="small"
                  fullWidth
                  className={classes.input}
                  disabled={stateK}
                />
              </TableCell>
              {/* Monto sin igv */}
              <TableCell align="right">
                {currency((productSelected.quantity || 0) * (productSelected.unit_price || 0)) ||
                  '-'}
              </TableCell>

              {/* Monto con igv */}
              <TableCell>
                {currency((productSelected.quantity || 0) * (productSelected.unit_price || 0)) ||
                  '-'}
              </TableCell>

              {/* Agregar detalle */}
              <TableCell align="center">
                <AllowedGuard permission={ConstantPermissions[permission.update]}>
                  <Button
                    type="submit"
                    justIcon
                    round
                    size="sm"
                    color={props.themeContext.buttonColorSuccess}
                    onClick={() => {
                      if (!!productSelected.id) {
                        saveDetail(productSelected);
                      } else {
                        showNotify('Elija un producto', 'info');
                      }
                    }}
                    disabled={stateK || isButtonDisabled}
                  >
                    <DoneAll />
                  </Button>
                </AllowedGuard>
              </TableCell>
            </TableRow>
            {productSelecteds.map((pSelect, i) => {
              return (
                <TableRow key={pSelect.id}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{pSelect.ItemCode || '-'}</TableCell>
                  <TableCell>{pSelect.ItemName || '-'}</TableCell>
                  <TableCell align="center">{pSelect.AcctCode || '-'}</TableCell>
                  <TableCell align="center">
                    {pSelect.NumPerMsr !== undefined
                      ? `${pSelect.unitMsr} (${parseFloat(pSelect.NumPerMsr)})`
                      : '-'}
                  </TableCell>
                  <TableCell align="center">PZA (1)</TableCell>
                  <TableCell align="right" key={pSelect.last_purchase_price}>
                    {pSelect.locked_price === 'N' ? (
                      <TextField
                        name="unit_price"
                        value={parseFloat(pSelect.unit_price || 0) || ''}
                        onChange={(e) => handleChangeRow(e, pSelect.id)}
                        onBlur={(e) => {
                          updateDetail(pSelect.id, { price: e.target.value });
                        }}
                        type="number"
                        margin="normal"
                        size="small"
                        inputProps={{ min: 0 }}
                        fullWidth
                        className={classes.input}
                        disabled={stateK}
                      />
                    ) : (
                      currency(pSelect.unit_price) || '-'
                    )}
                  </TableCell>

                  {/* Stock disponible */}
                  <TableCell>{parseInt(pSelect.stock.OnHand - pSelect.stock.IsCommited)}</TableCell>

                  {/* Cantidad */}
                  <TableCell>
                    <TextField
                      name="quantity"
                      value={pSelect.quantity || ''}
                      onChange={(e) => handleChangeRow(e, pSelect.id)}
                      onBlur={(e) => {
                        updateDetail(pSelect.id, { quantity: e.target.value });
                      }}
                      onKeyPress={onlyInteger}
                      margin="normal"
                      size="small"
                      fullWidth
                      className={classes.input}
                      disabled={stateK}
                    />
                  </TableCell>

                  {/* Monto sin igv */}
                  <TableCell align="right">{currency(pSelect.total) || '-'}</TableCell>

                  {/* Monto con igv */}
                  <TableCell>
                    {currency(pSelect.total * (1 + pSelect.TaxRateAP / 100)) || '-'}
                  </TableCell>

                  {/* Eliminar detalle */}
                  <TableCell align="center">
                    <>
                      <AllowedGuard permission={ConstantPermissions[permission.update]}>
                        <ButtonDelete
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorDanger}
                          disabled={stateK}                          
                          entity={`${entity}/${dataHeader.id}/detail`}
                          id={pSelect.id}
                          reload={() => getKardex(dataHeader.id)}
                        >
                          <Close />
                        </ButtonDelete>
                      </AllowedGuard>
                    </>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell colSpan={8} align="right">
                <b>Total</b>
              </TableCell>
              <TableCell align="right">
                <b>{productSelecteds?.reduce((a, b) => a + parseInt(b.quantity || 0), 0)}</b>
              </TableCell>
              {/* Total */}
              <TableCell align="right">
                <b>
                  {currency(productSelecteds?.reduce((a, b) => a + parseFloat(b.total || 0), 0))}
                </b>
              </TableCell>
              {/* Total con igv */}
              <TableCell align="right">
                <b>
                  {currency(productSelecteds?.reduce((a, b) => a + parseFloat(b.total * (1 + (b.TaxRateAP / 100)) || 0), 0))}
                </b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {dataHeader.state_migrate === 'D' && productSelecteds?.length > 0 ? (
        <>
          <AllowedGuard permission={ConstantPermissions[permission.store]}>
            <Button
              color={props.themeContext.buttonColorSuccess}
              style={{ marginTop: '15px', float: 'right' }}
              onClick={() => {
                changeStateK('V');
              }}
              disabled={isButtonDisabled}
            >
              Validar
            </Button>
          </AllowedGuard>
        </>
      ) : dataHeader.state_migrate === 'V' ? (
        <>
          <AllowedGuard permission={ConstantPermissions[permission.store]}>
            <Button
              color={props.themeContext.buttonColorWarning}
              style={{ marginTop: '15px', float: 'right' }}
              onClick={() => {
                changeStateK('D');
              }}
              disabled={isButtonDisabled}
            >
              Editar
            </Button>
          </AllowedGuard>

          <AllowedGuard permission={ConstantPermissions[permission.confirm]}>
            <Button
              color={props.themeContext.buttonColorSuccess}
              style={{ marginTop: '15px', float: 'right', marginRight: '10px' }}
              onClick={() => {
                changeStateK('X');
              }}
              disabled={isButtonDisabled}
            >
              Aprobar
            </Button>
          </AllowedGuard>
        </>
      ) : undefined}
    </>
  );
});
